import type { BadgeTone } from '@dental-staffing-platform/ui';

export const humanize = (s: string): string =>
  s.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());

export const credentialTone = (s: string): BadgeTone =>
  s === 'approved'
    ? 'success'
    : s === 'rejected'
      ? 'danger'
      : s === 'expired'
        ? 'warning'
        : 'neutral';

export const professionalTone = (s: string): BadgeTone =>
  s === 'active' ? 'success' : s === 'suspended' ? 'danger' : 'warning';
